import { inject, Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { catchError, firstValueFrom, map, Observable } from 'rxjs';
import { Endpoint } from '@pcp/http';
import { PCP_LOGGER } from '@pcp/logging';

@Injectable({
    providedIn: 'root',
})
export class LessonYjsApiService {
    private readonly endpoint = inject(Endpoint);
    private readonly log = inject(PCP_LOGGER).createScoped('yjs');

    getLessonYjsState(lessonId: string, documentId: string): Observable<Uint8Array | null> {
        return this.endpoint
            .get<ArrayBuffer>(
                `/api/yjs/${lessonId}/state`,
                'arraybuffer',
                new HttpParams().set('documentId', documentId)
            )
            .pipe(
                map(response => {
                    // 204 No Content: Angular HttpClient returns empty ArrayBuffer (byteLength === 0)
                    // 200 OK: Returns ArrayBuffer with Yjs state bytes
                    if (!response || (response instanceof ArrayBuffer && response.byteLength === 0)) {
                        return null;
                    }
                    return new Uint8Array(response);
                }),
                catchError(error => {
                    // Carries the identifiers, which the bare logException() did not — a failed
                    // state fetch is unactionable without knowing which lesson and document.
                    this.log.error(
                        'Failed to fetch lesson Y.Doc state',
                        error instanceof Error ? error : undefined,
                        { lessonId, documentId },
                    );
                    throw error;
                })
            );
    }

    fetchLessonYjsState(lessonId: string, documentId: string): Promise<Uint8Array | null> {
        return firstValueFrom(this.getLessonYjsState(lessonId, documentId));
    }
}
